<script>
import Layout from '@layouts/main.vue'
import { mapState } from 'vuex'
import PixelPresence from '@components/embed/PixelPresence/PixelPresence.vue'
import ConnectDomainModal from '@components/modals/ConnectDomainModal/ConnectDomainModal.vue'
import appConfig from '@src/app.config.json'

export default {
  page: {
    title: 'Embed',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  name: 'PixelView',
  components: {
    ConnectDomainModal,
    Layout,
    'pixel-presence-component': PixelPresence,
  },
  data() {
    return {
      connectDomainModalVisible: false,
      connectDomainTarget: '',
    }
  },
  computed: {
    ...mapState({
      areCampaignsLoaded: (state) => state.campaign.areCampaignsLoaded,
    }),
    allCampaignDomains() {
      return this.$store.getters['campaign/getAllCampaignDomains']
    },
  },
  methods: {
    triggerConnectDomain(target) {
      this.connectDomainTarget = target
      this.connectDomainModalVisible = true
    },
  },
}
</script>

<template>
  <Layout>
    <el-row id="pixel-view" :class="$style.pixel">
      <el-col :span="24" :md="{ span: 22, offset: 1 }">
        <h1 class="has-subheading">Embed</h1>
        <p>Copy the Onvocado code snippet and place it on your website</p>

        <div class="container no-padding">
          <div class="mb-8 flex flex-row gap-4">
            <div class="w-44 h-32 bg-white rounded shadow border flex items-center justify-center cursor-pointer"
                 @click.stop="triggerConnectDomain('wordpress')">
              <img src="/integrations/WordPress.png" alt="Wordpress Logo">
            </div>

            <div
                class="w-44 h-32 bg-white rounded shadow border flex items-center justify-center cursor-pointer"
                @click.stop="triggerConnectDomain('bigcommerce')">
              <img src="/integrations/BigCommerce.svg" alt="BigCommerce Logo">
            </div>

            <div
                class="w-44 h-32 p-6 bg-white rounded shadow border flex items-center justify-center cursor-pointer"
                @click.stop="triggerConnectDomain('googletagmanager')">
              <img src="/integrations/gtag.webp" alt="Google Tag Manager Logo">
            </div>

            <div
                class="w-44 h-32 p-4 relative bg-white rounded shadow border flex items-center justify-center opacity-30">
              <img src="/integrations/shopify_logo.png" alt="Shopify Logo">
              <span class="absolute top-3 left-3 text-sm">Coming soon! <i class="el-icon-watch"></i></span>
            </div>

            <div class="w-44 h-32 p-10 relative bg-white rounded shadow border flex items-center justify-center opacity-30">
              <img src="/integrations/Wix.png" alt="Wix Logo">
              <span class="absolute top-3 left-3 text-sm">Coming soon! <i class="el-icon-watch"></i></span>
            </div>
          </div>
          <template v-if="areCampaignsLoaded">
            <pixel-presence-component :show-f-a-q="true"></pixel-presence-component>
          </template>

          <template v-else>
            <Loader></Loader>
          </template>

          <ConnectDomainModal :modal-visible="connectDomainModalVisible"
                              :target-platform="connectDomainTarget"
                              @close-modal="connectDomainModalVisible = false"/>
        </div>
      </el-col>
    </el-row>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.customDropdownContainer {
  margin-bottom: 20px;
}

.customDropdown {
  min-width: 250px;
  border-bottom: 1px solid $color-grey;

  input {
    height: 21px;
    padding: 0 5px;
    color: $color-text-primary;
    background-color: transparent;
    border: none;
  }

  i {
    line-height: 21px;
    color: $color-text-primary !important;
  }
}

.pixelCheck {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  padding: 20px 20px;
  margin-bottom: 40px;
  background-color: lighten($color-contrast, 20%);

  h5 {
    color: darken($color-danger, 20);
  }
}

.red {
  composes: pixelCheck; /* stylelint-disable-line */
  background-color: lighten($color-danger, 20%);
}

.green {
  composes: pixelCheck; /* stylelint-disable-line */
  background-color: lighten($color-success, 58%);
}
</style>
